import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getUserAccessById } from "../Services/Users.service";

interface AuthState {
  isLoggedIn: boolean;
  userId: string | null;
  userRole: string | null;
}

const initialState: AuthState = {
  isLoggedIn: !!localStorage.getItem("loginemail"),
  userId: localStorage.getItem("loginemail") || null,
  userRole: localStorage.getItem("userRole") || null,
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, action: PayloadAction<{ email: string, role: string }>) => {
      state.isLoggedIn = true;
      state.userId = action.payload.email;
      state.userRole = action.payload.role;
      localStorage.setItem("loginemail", action.payload.email);
      localStorage.setItem("userRole", action.payload.role);
      
      // Call getUserAccessById asynchronously without blocking the reducer
      if (action.payload.email && action.payload.email.trim() !== '') {
        getUserAccessById(action.payload.email).catch(error => {
          console.warn('Failed to fetch user access data:', error);
        });
      }
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.userId = null;
      state.userRole = null;
      localStorage.removeItem("loginemail");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("userId");
      localStorage.removeItem("userRole");
      localStorage.removeItem("userTimeZone");
      localStorage.removeItem("userUOM");
    },
  },
});

export const { login, logout } = authSlice.actions;
export default authSlice.reducer;
